(function () {
  'use strict';

  angular
    .module('web2print.shared')
    .factory('FeatureToggleFactory', FeatureToggleFactory);

  FeatureToggleFactory.$inject = ['$localStorage'];

  /* @ngInject */
  function FeatureToggleFactory ($localStorage) {
    const service = {
      isFeatureEnabled: isFeatureEnabled,
      toggleFeature: toggleFeature,
      getFeatures: getFeatures
    };

    return service;

    function isFeatureEnabled (feature) {
      return !!_.get($localStorage.enabledFeatures, feature);
    }

    function toggleFeature (feature, value) {
      $localStorage.enabledFeatures[feature] = value;
    }

    function getFeatures () {
      $localStorage.enabledFeatures = web2print.env.enableFeatureToggle
        ? $localStorage.enabledFeatures || {} : web2print.env.enabledFeatures;
      let features = [
        {name: 'materialDownloadLink', title: 'PDF creation instructions download link'},
        {name: 'odrEnabled', title: 'ODR'},
        {name: 'odr', title: 'ODR tab in landing page'}
      ];

      features = _.map(features, function (feature) {
        return {
          name: feature.name,
          title: feature.title,
          value: $localStorage.enabledFeatures[feature.name]
        };
      });

      return features;
    }
  }
})();
